import { render, staticRenderFns } from "./Presupuesto.vue?vue&type=template&id=18a696f4&scoped=true"
import script from "./Presupuesto.vue?vue&type=script&lang=js"
export * from "./Presupuesto.vue?vue&type=script&lang=js"
import style0 from "./Presupuesto.vue?vue&type=style&index=0&id=18a696f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a696f4",
  null
  
)

export default component.exports